import React from "react";
import Panel from "muicss/lib/react/panel";
import axios from "axios";
import reduce from "lodash/reduce";
import filter from "lodash/filter";
import BigNumber from "bignumber.js";
/* import Cell from 'recharts/lib/component/Cell';
import PieChart from 'recharts/lib/chart/PieChart';
import Pie from 'recharts/lib/polar/Pie'; */
import * as lumens from "../../common/lumens.js";
import { totalCoins, totalFeePool } from "../../common/lumens.js";

const BILLION = Math.pow(10, 9);

export default class InflationProgress extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      payableInflation: 1,
      WeeklyInflation: 1,
      totalCoins: 1,
      chartWidth: 400,
      allVote: 1,
      listOfAccount: [],
      chartHeigth: this.props.chartHeigth || 200,
    };
  }

  updateWeeklyInflation() {
    Promise.all([
      totalCoins(this.props.horizonURL),
      totalFeePool(this.props.horizonURL),
    ]).then((data) => {
      var amount = (0.12 * parseInt(data[0]) + parseInt(data[1])) / 52;

      this.setState({ WeeklyInflation: amount });
    });
  }

  updatePayableInflation() {
    var payableInflation = 0;
    console.log(this.state.listOfAccount);
    this.state.listOfAccount.map((itemsmap) => {
      if (itemsmap.voted >= this.state.totalCoins * 0.05) {
        payableInflation =
          payableInflation +
          (itemsmap.voted / this.state.allVote) * this.state.WeeklyInflation;
      }
      console.log("payableInflation");
      console.log(payableInflation);
      console.log("------------");
      this.setState({ payableInflation });
    });
  }

  componentDidMount() {
    var api = "http://212.80.25.153:3000/api/accounts/";
    var listOfAccount = [];
    var allVote = 0;

    totalCoins(this.props.horizonURL).then((amount) => {
      this.setState({ totalCoins: amount });
    });

    this.updateWeeklyInflation();

    fetch(api)
      .then((response) => {
        const statusCode = response.status;
        const data = response.json();
        return Promise.all([statusCode, data]);
      })
      .then((res) => {
        if (res[0] == 200) {
          this.setState({ accounts: res[1] });

          res[1].map((itemsmap) => {
            if (
              listOfAccount.some((el) => {
                return el.id == itemsmap.inflationdest;
              })
            ) {
              listOfAccount[
                listOfAccount.findIndex((x) => x.id === itemsmap.inflationdest)
              ].voted += itemsmap.balance / 10000000;
              allVote += itemsmap.balance / 10000000;
            } else {
              var addingVote = itemsmap.balance / 10000000;
              listOfAccount.push({
                id: itemsmap.inflationdest,
                voted: addingVote,
              });
              allVote += addingVote;
            }

            this.setState({ listOfAccount, allVote });
            console.log("listOfAccount");
            console.log(listOfAccount);
            console.log("-------------");
          });
        }
      });
    setInterval(() => this.updatePayableInflation(), 5000);
  }

  displayNumber(num) {
    if (num >= 1000000000) {
      return Math.floor(num / 10000000) / 100 + "B";
    } else if (num >= 1000000) {
      return Math.floor(num / 10000) / 100 + "M";
    } else if (num < 1000000 && num >= 100000) {
      return Math.floor(num / 1000) + "k";
    } else {
      return Math.floor(num);
    }
  }

  render() {
    return (
      <Panel>
        <div className="widget-name">
          <h3>
            {this.props.dictionary["currentInflationRanking"][this.props.lang]}
          </h3>
          <h5>
            {this.props.dictionary["totalVote"][this.props.lang]}:{" "}
            <span>{this.displayNumber(this.state.allVote)}</span>
          </h5>
          <h5>
            {this.props.dictionary["payableInflation"][this.props.lang]}:{" "}
            <span>{this.displayNumber(this.state.payableInflation)}</span>
          </h5>
          <h5>
            {this.props.dictionary["willTransferToNextWeek"][this.props.lang]}:{" "}
            <span>
              {this.displayNumber(
                this.state.WeeklyInflation - this.state.payableInflation,
              )}
            </span>
          </h5>
        </div>
        {this.state.loading ? (
          "Loading..."
        ) : (
          <table className="mui-table small">
            <thead>
              <tr>
                <th>{this.props.dictionary["status"][this.props.lang]}</th>
                <th>{this.props.dictionary["percent"][this.props.lang]}</th>
                <th>{this.props.dictionary["willReceive"][this.props.lang]}</th>
                <th>{this.props.dictionary["account"][this.props.lang]}</th>
                <th>{this.props.dictionary["votes"][this.props.lang]}</th>
              </tr>
            </thead>
            <tbody>
              {[...this.state.listOfAccount].map((itemsmap) => {
                return (
                  <tr>
                    {this.state.listOfAccount != [] &&
                    this.state.totalCoins != 1 &&
                    itemsmap.voted >= this.state.totalCoins * 0.05 ? (
                      <td>
                        <div className="bgreen"></div>
                      </td>
                    ) : (
                      <td>
                        <div className="bred"></div>
                      </td>
                    )}

                    <td>{(itemsmap.voted / this.state.allVote) * 100}%</td>
                    {this.state.listOfAccount != [] &&
                    this.state.totalCoins != 1 &&
                    itemsmap.voted >= this.state.totalCoins * 0.05 ? (
                      <td>
                        {this.displayNumber(
                          (itemsmap.voted / this.state.allVote) *
                            this.state.WeeklyInflation,
                        )}{" "}
                        PMN
                      </td>
                    ) : (
                      <td>0 PMN</td>
                    )}

                    <td>
                      <a
                        href={`${this.props.horizonURL}/accounts/${itemsmap.id}`}
                        target="_blank"
                      >
                        {itemsmap.id.substring(0, 5)}
                      </a>
                    </td>
                    <td>{this.displayNumber(itemsmap.voted)}</td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        )}
      </Panel>
    );
  }
}



// WEBPACK FOOTER //
// ./frontend/components/InflationProgress.js